// const DetailDateTimeFormatter = (timestamp) => {
// const date = new Date(timestamp);
// const options = {
//   // weekday: "short", // Mon
//   year: "numeric", // YYYY
//   month: "short", // Dec
//   // day: "2-digit", // DD
//   hour: "numeric", // HH
//   minute: "2-digit", // MM
//   second: "2-digit", // SS
//   hour12: true, // AM/PM format
// };
// return new Intl.DateTimeFormat("en-US", options).format(date);
import { format } from 'date-fns';

const DetailDateTimeFormatter = (dateTime) => {
  if (!dateTime) return '';
  const date = new Date(dateTime);
  // Adding comma between date and time
  return format(date, 'MMM d yyyy, h:mm a');
};

export default DetailDateTimeFormatter;
